import { Component, OnInit, Inject, ViewChild } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { ThanhVienPhanQuyenChucNang } from 'src/app/shared/ThanhVienPhanQuyenChucNang.model';
import { ThanhVienPhanQuyenChucNangService } from 'src/app/shared/ThanhVienPhanQuyenChucNang.service';
import { MatTableDataSource } from '@angular/material/table';
import { MatSort } from '@angular/material/sort';
import { MatPaginator } from '@angular/material/paginator';
import { ThanhVien } from 'src/app/shared/ThanhVien.model';
import { ThanhVienService } from 'src/app/shared/ThanhVien.service';
import { NotificationService } from 'src/app/shared/Notification.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-danh-muc-chuc-nang-detail-thanh-vien',
  templateUrl: './danh-muc-chuc-nang-detail-thanh-vien.component.html',
  styleUrls: ['./danh-muc-chuc-nang-detail-thanh-vien.component.css']
})
export class DanhMucChucNangDetailThanhVienComponent implements OnInit {
  
  @ViewChild('ThanhVienPhanQuyenChucNangSort004') ThanhVienPhanQuyenChucNangSort004: MatSort;
  @ViewChild('ThanhVienPhanQuyenChucNangPaginator004') ThanhVienPhanQuyenChucNangPaginator004: MatPaginator;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialogRef: MatDialogRef<DanhMucChucNangDetailThanhVienComponent>,
    public ThanhVienPhanQuyenChucNangService: ThanhVienPhanQuyenChucNangService,
    public ThanhVienService: ThanhVienService,
    public NotificationService: NotificationService
  ) { }

  ngOnInit(): void {
    this.GetData();
  }

  
  ThanhVienPhanQuyenChucNangSave(element: ThanhVienPhanQuyenChucNang) {
    // if(element.AgencyDepartmentID > 0 && element.Active != true){
    //   this.ThanhVienPhanQuyenChucNangDelete(element);
    //   return;
    // }
    // this.DanhMucChucNangService.IsShowLoading = true;
    this.ThanhVienPhanQuyenChucNangService.FormData = element;
    this.ThanhVienPhanQuyenChucNangService.FormData.DanhMucChucNangID = this.data.chucNangId;
    this.ThanhVienPhanQuyenChucNangService.SaveAsync().subscribe(
      res => {
        this.GetData();
        this.NotificationService.warn(environment.SaveSuccess);
        // this.DanhMucChucNangService.IsShowLoading = false;
      },
      err => {
        this.NotificationService.warn(environment.SaveNotSuccess);
        // this.DanhMucChucNangService.IsShowLoading = false;
      }
    );
  }

  GetAgencyDepartmentNameByID(thanhVienId: number) {
    return this.ThanhVienService.List.find(x => x.ID === thanhVienId)?.Name;
  }

  GetData() {


    if (this.data.agencyDepartmentId > 0) {
      this.ThanhVienService.BaseParameter.AgencyDepartmentID = this.data.agencyDepartmentId;
      this.ThanhVienService.GetByAgencyDepartmentIDToListAsync().subscribe(res => {
        this.ThanhVienService.List = (res as ThanhVien[]);
        
          // this.AgencyDepartmentService.IsShowLoading = true;
        this.ThanhVienPhanQuyenChucNangService.BaseParameter.ListID = this.ThanhVienService.List.map(x => x.ID);
        this.ThanhVienPhanQuyenChucNangService.BaseParameter.DanhMucChucNangID = this.data.chucNangId
        this.ThanhVienPhanQuyenChucNangService.GetSQLByListParentIDAndChucNangIDToListAsync().subscribe(
          res => {
            this.ThanhVienPhanQuyenChucNangService.List = (res as ThanhVienPhanQuyenChucNang[]);
            this.ThanhVienPhanQuyenChucNangService.DataThanhVienThamgia = new MatTableDataSource(this.ThanhVienPhanQuyenChucNangService.List);
            this.ThanhVienPhanQuyenChucNangService.DataThanhVienThamgia.sort = this.ThanhVienPhanQuyenChucNangSort004;
            this.ThanhVienPhanQuyenChucNangService.DataThanhVienThamgia.paginator = this.ThanhVienPhanQuyenChucNangPaginator004;
            // this.AgencyDepartmentService.IsShowLoading = false;
          },
          err => {
            // this.AgencyDepartmentService.IsShowLoading = false;
          }
        );
      });
    }
  }

}

